<template lang="pug">
section.vaccine-status
    .subheading Vaccinations
    .status(v-if="typeof vax === 'undefined'") Not Started
    .status.red.big(v-else-if="incomplete") Incomplete
    .status(v-else-if="expired")
        span.red.big Expired 
        span Needs Update
    .status(v-else)
        span.green.big Valid 
        span thru 
        span.big {{ expiration }}
</template>

<script setup lang="ts">
import { Dogspaces } from '@busy-human/k9-library';
import { computed } from 'vue';

type Props = {
    vax?: Dogspaces.Model['vaccines']
}
const props = defineProps<Props>();

type Emits = {
    (e: 'click'): void
}
defineEmits<Emits>();

const incomplete = computed(() => {
    if(!props.vax) return true;
    if(Object.keys(props.vax).length < 4) return true;
})

const expired = computed(() => {
    if(!props.vax) return true;
    const dates = Object.values(props.vax).map(v => new Date(v.expires));
    const today = new Date().getTime();
    for(const date of dates) {
        if(date.getTime() < today) return true;
    }
    return false;
})

const expiration = computed(() => {
    if(!props.vax) return null;
    const dates = Object.values(props.vax).map(v => new Date(v.expires)).sort((a, b) => a.getTime() - b.getTime());
    return dates[0].toLocaleDateString('default', {year: '2-digit', month: '2-digit', day: '2-digit'})
})

</script>

<style lang="scss">
section.vaccine-status {
    border: 1px solid rgba(black, .38);
    border-radius: .25rem;
    padding: 0.5rem;

    .red {
        color: darkred;
    }
    .green {
        color: #00BBAE;
    }
    .big {
        font-size: 1.5em;
    }
}
</style>